import routerOptions from './router.options';

import coreRoutes from './_core.routes';
import homeRoutes from './home.routes';
import menuRoutes from './menu.routes';
import notFoundRoutes from './not-found.routes';

import afterEach from './hooks/after-each.hooks';
import beforeEach from './hooks/before-each.hooks';
import beforeResolve from './hooks/before-resolve.hooks';

const routes = [
  ...homeRoutes,
  ...menuRoutes,
  ...notFoundRoutes,

  ...coreRoutes, // (!) Always last
];

const hooks = {
  afterEach,
  beforeEach,
  beforeResolve,
};

export {
  hooks,
  routerOptions,
  routes,
};
